// extracted by mini-css-extract-plugin
module.exports = {"coin":"styles_coin__n07cc","text":"styles_text__wVecC","skeleton-animation":"styles_skeleton-animation__DDwG0"};